import { render } from "./ConcernPersonModal.vue?vue&type=template&id=03b47d72&scoped=true"
import script from "./ConcernPersonModal.vue?vue&type=script&lang=js"
export * from "./ConcernPersonModal.vue?vue&type=script&lang=js"

import "./ConcernPersonModal.vue?vue&type=style&index=0&id=03b47d72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03b47d72"]])

export default __exports__